<template>
  <f7-page>
    <div>
      <div class="custom-table-container tableContainer">
        <showDetailsPopUp :store="detallesLineas" />
      </div>
      <!-- <GoBack class="margin" /> -->
    </div>
  </f7-page>
</template>
<script>
import showDetailsPopUp from '@/components/OffersList/showDetailsPopUp/index.vue';
import { mapState, mapActions } from 'vuex';
// import { NOTIFY_TIME_LONG } from '@/js/constants';
// import GoBack from '@/components/UtilityComponents/GoBack/index.vue';

export default {
  components: { showDetailsPopUp },
  data() {
    return {
      loaded: false,
      customStore: null,
    };
  },
  computed: {
    ...mapState('contact', ['company', 'addresses']),
    ...mapState('Offers', ['presupuestos', 'detallesLineas']),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('offersDetails'),
        disabled: false,
        page: 'offersDetails',
        active: true,
      },
    ]);
  },
  //   async mounted() {
  //     try {
  //       this.$f7.preloader.show();
  //     } catch (error) {
  //       this.$notifyDX(
  //         {
  //           message: this.$t(
  //             this.$helpers.getFilteredErrorMessage(error.message)
  //           ),
  //           width: 550,
  //         },
  //         'error',
  //         NOTIFY_TIME_LONG
  //       );
  //     } finally {
  //       this.$f7.preloader.hide();
  //       this.loaded = true;
  //     }
  //   },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('Offers', ['fetchPresupuestos']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
    ...mapActions('OffersListFilters', ['setSelectedStatuses']),
  },
};
</script>
